
export const formatTimestampToDate = (timestamp) => {
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    weekday: 'short'
  });
};

export const calculateDeliveryRate = (sent, delivered) => {
  if (sent === 0) return 0;
  return parseFloat(((delivered / sent) * 100).toFixed(1));
};

export const transformDatapointsToDailyData = (datapoints = []) => {
  return datapoints.map((point) => {
    const { start, end, sent = 0, delivered = 0 } = point;
    const failed = sent - delivered;
    const rate = calculateDeliveryRate(sent, delivered);
    const date = formatTimestampToDate(start);
    
    return {
      date,
      sent,
      delivered,
      failed,
      rate,
      startTimestamp: start,
      endTimestamp: end,
    };
  });
};

export const calculateTotalMetrics = (dailyData = []) => {
  const totals = dailyData.reduce(
    (acc, day) => ({
      sent: acc.sent + (day.sent || 0),
      delivered: acc.delivered + (day.delivered || 0),
      failed: acc.failed + (day.failed || 0),
    }),
    { sent: 0, delivered: 0, failed: 0 }
  );

  return {
    ...totals,
    rate: calculateDeliveryRate(totals.sent, totals.delivered),
  };
};

export const getDateRangeTimestamps = (days) => {
  const now = new Date();
  const endTime = Math.floor(now.getTime() / 1000);
  const startTime = Math.floor((now.getTime() - days * 24 * 60 * 60 * 1000) / 1000);
  
  return { start: startTime, end: endTime };
};

export const groupDataByPeriod = (dailyData = [], groupByDays = 7) => {
  if (dailyData.length === 0) return [];
  
  const groups = [];
  let currentGroup = {
    startDate: dailyData[0].date,
    sent: 0,
    delivered: 0,
    failed: 0,
    days: [],
  };
  
  dailyData.forEach((day, index) => {
    currentGroup.sent += day.sent;
    currentGroup.delivered += day.delivered;
    currentGroup.failed += day.failed;
    currentGroup.days.push(day);
    
    if ((index + 1) % groupByDays === 0 || index === dailyData.length - 1) {
      currentGroup.endDate = day.date;
      currentGroup.rate = calculateDeliveryRate(currentGroup.sent, currentGroup.delivered);
      groups.push(currentGroup);
      currentGroup = {
        startDate: null,
        sent: 0,
        delivered: 0,
        failed: 0,
        days: [],
      };
    }
  });
  
  return groups;
};

export const isDataStale = (lastFetchTime, maxAgeHours = 24) => {
  const now = Date.now();
  const ageMs = now - lastFetchTime;
  const maxAgeMs = maxAgeHours * 60 * 60 * 1000;
  
  return ageMs > maxAgeMs;
};

export const formatLargeNumber = (num) => {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + 'B';
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
};
